import { render, staticRenderFns } from "./orderServicerOutsource.vue?vue&type=template&id=c9529eb8&"
import script from "./orderServicerOutsource.vue?vue&type=script&lang=ts&"
export * from "./orderServicerOutsource.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports